<template>
  <div class="flex_sp" style="width: 100%">
    <div class="two" v-for="item in data.floor" :key="item.id" :style="{ backgroundImage: `url(${item.bj_img})` }">
      <div class="tile_wrap">
        <div class="left">
          <img class="img" :src="item.icon" alt="" />
        </div>
        <div class="right" @click="handleJump(item.jump)">
          <span>更多</span>
          <div class="more">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="top_img">
          <img :src="item.adv.image" alt="" />
        </div>
        <div class="item_box">
          <div class="item" v-for="sub in item.goodsArr" :key="sub.id" @click="handleDetail(sub.id)">
            <div class="img">
              <img :src="sub.image.url" alt="" />
            </div>
            <p class="pr">￥{{ sub.price }}</p>
            <p class="til shenglue_1">{{ sub.title }}</p>
            <p class="shenglue_1 f12">{{ sub.specification }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleJump } from "@/utils";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      handleJump,
    };
  },
  methods: {
    handleDetail(id) {
      const { href } = this.$router.resolve({
        path: "/index/goodsDetail",
        query: { id },
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.two {
  width: 595px;
  background: #ffffff;
  border-radius: 4px;
  margin-top: 20px;
  background-size: cover;
  .tile_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 20px;
    .left {
      display: flex;
      align-items: center;
      .img {
        width: 120px !important;
        height: 29px !important;
      }
    }
    .right {
      display: flex;
      align-items: center;
      cursor: pointer;
      .more {
        width: 9px;
        height: 16px;
        margin-left: 10px;
      }
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .main {
    padding: 20px;
    padding-top: 0;
    .top_img {
      width: 100%;
      height: 200px;
      border-radius: 4px;
      cursor: pointer;
    }
    .item_box {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .item {
        padding: 10px;
        box-sizing: border-box;
        width: 178px;
        height: 250px;
        border: 1px solid #dddddd;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        &:hover {
          box-shadow: 0px 0px 20px 0px rgba(221, 221, 221, 0.8);
          border: 1px solid #fff;
        }
        .img {
          width: 150px;
          height: 150px;
          margin-bottom: 10px;
        }
        .til {
          font-weight: bold;
          color: #333333;
          margin-bottom: 6px;
        }
        .pr {
          font-size: 16px;
          font-weight: bold;
          margin-top: 6px;
          color: @priceRed;
        }
      }
    }
  }
}
</style>
